import { COLLECTION_NAME } from ".";
import { updateDocument } from "db/mutations";
import { post } from "db/api";

export const createCustomer = async (userId, userData) => {
  try {
    const response = await post("/create-customer", userData);
    const data = await response.json();

    if (!response.ok) {
      console.error("Error en la función:", data.error);
      return;
    }

    await updateDocument(COLLECTION_NAME, userId, {
      customerId: data.id,
    });

    return { success: true, customerId: data.id };
  } catch (error) {
    console.error("Error inesperado:", error.message);
    return { success: false, error: error.message };
  }
};
